





























































































import { formSelectOptions }                from '$/lib/utils';
import { Vue, Component, Prop, Ref, Watch } from '$/lib/vueExt';

import type { BuildingUnit as BuildingUnitJSONable } from '$/entities/Building';
import { BuildingUnitType, bedroomOptions }          from '$/entities/Building';

enum Mode {
	New     = 'new',     // with an add button
	Editing = 'editing', // with a save button and a delete button
	Label   = 'label',   // blank box showing the unit label
}

@Component
export default class BuildingUnit extends Vue {

	@Ref()
	readonly unitForm: any;

	@Prop()
	readonly unit: BuildingUnitJSONable;

	@Prop()
	readonly mode: Mode;
	localMode: Mode = Mode.Label;

	@Watch('mode', { immediate : true })
	onModeChange() {
		this.localMode = this.mode;
	}

	get unitTypeOptions() {
		return formSelectOptions(BuildingUnitType, { invert : true });
	}

	get bedroomOptions() {
		return bedroomOptions;
	}

	async saveUnit() {
		if (await this.unitForm.isValid()) {
			if (this.isEditing) {
				this.localMode = Mode.Label;
			}

			this.$emit('save');
		}
	}

	editUnit() {
		this.localMode = Mode.Editing;
	}

	deleteUnit() {
		this.$emit('delete');
		this.localMode = this.mode;
	}

	get isEditing() {
		return this.localMode === Mode.Editing;
	}

	get isNew() {
		return this.localMode === Mode.New;
	}

	get isLabel() {
		return this.localMode === Mode.Label;
	}

}
